var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropertyInsurance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#paint0_linear_2157_56)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1437 6C24.1437 6 15.6761 12.4204 10.2505 12.4204V28.1143C10.2505 30.8589 11.6053 33.4265 13.8708 34.9756L24.1437 42L34.4166 34.9756C36.6822 33.4265 38.037 30.8589 38.037 28.1143V12.4204C32.6113 12.4204 24.1437 6 24.1437 6ZM15.6863 22.1351L22.7141 14.7236C23.6289 13.7588 25.1121 13.7588 26.027 14.7236L33.0547 22.1351C33.4941 22.5984 33.7409 23.2268 33.7409 23.882V31.5054C33.7409 32.1876 33.2165 32.7407 32.5696 32.7407H27.2988C26.9753 32.7407 26.7131 32.4642 26.7131 32.1231V27.7997C26.7131 26.4353 25.6643 25.3292 24.3705 25.3292C23.0768 25.3292 22.0279 26.4353 22.0279 27.7997V32.1231C22.0279 32.4642 21.7657 32.7407 21.4423 32.7407H16.1715C15.5246 32.7407 15.0002 32.1876 15.0002 31.5054V23.882C15.0002 23.2268 15.247 22.5984 15.6863 22.1351Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2157_56",
    x1: 1.06167e-7,
    y1: 0.264664,
    x2: 49.2178,
    y2: 46.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB2CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE3D82"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyInsurance);
export default __webpack_public_path__ + "static/media/PropertyInsurance.d63ddfddc9495eb836151994863c3343.svg";
export { ForwardRef as ReactComponent };